import { formatMoney } from "@/shared/utils/formatters";

export function formatServicePrice(amount: number | null, currency?: string) {
  if (amount === null) return "Price not set";
  return currency ? formatMoney(amount, currency) : "Currency unavailable";
}

export function formatServiceMinutes(minutes: number | null) {
  return minutes === null ? "Not set" : `${minutes} min`;
}
